/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelocateScreenerResident200ResponseData } from './RelocateScreenerResident200ResponseData';
import {
    RelocateScreenerResident200ResponseDataFromJSON,
    RelocateScreenerResident200ResponseDataFromJSONTyped,
    RelocateScreenerResident200ResponseDataToJSON,
    RelocateScreenerResident200ResponseDataToJSONTyped,
} from './RelocateScreenerResident200ResponseData';

/**
 * 
 * @export
 * @interface RelocateScreenerResident200Response
 */
export interface RelocateScreenerResident200Response {
    /**
     * 
     */
    data?: RelocateScreenerResident200ResponseData;
}

/**
 * Check if a given object implements the RelocateScreenerResident200Response interface.
 */
export function instanceOfRelocateScreenerResident200Response(value: object): value is RelocateScreenerResident200Response {
    return true;
}

export function RelocateScreenerResident200ResponseFromJSON(json: any): RelocateScreenerResident200Response {
    return RelocateScreenerResident200ResponseFromJSONTyped(json, false);
}

export function RelocateScreenerResident200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelocateScreenerResident200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : RelocateScreenerResident200ResponseDataFromJSON(json['data']),
    };
}

export function RelocateScreenerResident200ResponseToJSON(json: any): RelocateScreenerResident200Response {
    return RelocateScreenerResident200ResponseToJSONTyped(json, false);
}

export function RelocateScreenerResident200ResponseToJSONTyped(value?: RelocateScreenerResident200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': RelocateScreenerResident200ResponseDataToJSON(value['data']),
    };
}

